import React, { useEffect, useState } from 'react';
import {
  Card,
  CardBody,
  CardHeader,
  Label,
  FormGroup,
  Form,
  Button,
} from 'reactstrap';
import TagsInput from 'react-tagsinput';
import { useDispatch } from "react-redux";
import { useSelector } from 'react-redux';
import { useForm } from "react-hook-form";
import { useHistory } from 'react-router-dom';
import { actionSubmitPracticeExtRef } from 'store/actions/practicesActions';

const PracticesRefForm = () => {
  const dispatch = useDispatch();

  //States
  const practiceData = useSelector(state => state.practicesReducer.editData);
  const ext_ref = practiceData.ext_ref;
  const practiceId = practiceData._id;

  const [tags, setTags] = useState(ext_ref ? ext_ref : []);
  
  const { handleSubmit } = useForm({
    defaultValues: {
      ext_ref: ext_ref
    }
  });
  const history = useHistory();

  const onSubmit = () => {
    if (!tags.length) return;
    dispatch(actionSubmitPracticeExtRef(practiceId, tags));
  };

  return (
    <div className="content user-manual-edit">

      <Card>
        <CardHeader>{`${practiceData?.name} External Reference edition form`}</CardHeader>
        <CardBody>
          <Form id="user-edit-form" onSubmit={handleSubmit(onSubmit)}>

          <Label>External Reference</Label>
            <FormGroup>
              <TagsInput
                inputProps={{
                  name: 'tags',
                  placeholder: '',
                }}
                value={tags}
                tagProps={{ className: 'react-tagsinput-tag' }}
                onChange={setTags}
              />
              {!tags.length && ("Tag field cannot be empty.")}
            </FormGroup>
          </Form>

          <Button form="user-edit-form" size="sm" color="info" type="submit">
            Update
          </Button>

          <Button
            form="user-edit-form"
            size="sm"
            color="danger"
            type="reset"
            onClick={(e) => {
              e.preventDefault();
              history.goBack();
            }}
          >
            Cancel
          </Button>
        </CardBody>
      </Card>
    </div>
  );
};

export default PracticesRefForm;
